import React, { useState, useEffect } from "react";
import { Tab } from "@headlessui/react";
import AppAnalytics from "./AppAnalytics";
import AppSetting from "./AppSetting";
import AppSecurity from "./AppSecurity";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { instance as axios } from "../../../utils/axiosConfig";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function AppDashboard() {
  const params = useParams();
  const app_id = params.id;
  const [appDetails, setAppDetails] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const res = await axios.get(`/app-details/${app_id}`);
    setAppDetails(res.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="w-full py-3 sm:px-0">
          <div className="w-full p-3 mb-6 bg-yellow-100 border-l-4 border-l-yellow-400 rounded-md">
            <h1 className="mb-2">
              App Name : <span>{appDetails?.name}</span>
            </h1>
            <h1>
              App Type : <span>{appDetails?.type}</span>
            </h1>
            <h1 className="mt-2">
              App ID : <span>{app_id}</span>
            </h1>
          </div>
          <Tab.Group>
            <Tab.List className="flex space-x-1 rounded-xl bg-yellow-100 p-1">
              <Tab
                className={({ selected }) =>
                  classNames(
                    "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-yellow-900 focus:outline-none",
                    selected
                      ? "bg-yellow-200 shadow"
                      : "text-yellow-900 hover:bg-yellow-200 hover:text-yellow-900"
                  )
                }
              >
                Analytics
              </Tab>
              <Tab
                className={({ selected }) =>
                  classNames(
                    "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-yellow-900 focus:outline-none",

                    selected
                      ? "bg-yellow-200 shadow"
                      : "text-yellow-900 hover:bg-yellow-200 hover:text-yellow-900"
                  )
                }
              >
                Settings
              </Tab>
              <Tab
                className={({ selected }) =>
                  classNames(
                    "w-full rounded-lg py-2.5 text-sm font-medium leading-5 text-yellow-900 focus:outline-none",

                    selected
                      ? "bg-yellow-200 shadow"
                      : "text-yellow-900 hover:bg-yellow-200 hover:text-yellow-900"
                  )
                }
              >
                Security
              </Tab>
            </Tab.List>

            <Tab.Panels className="mt-4">
              <Tab.Panel>
                <AppAnalytics details={appDetails} />
              </Tab.Panel>
              <Tab.Panel>
                <AppSetting />
              </Tab.Panel>
              <Tab.Panel>
                <AppSecurity appId={app_id} />
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      )}
    </>
  );
}

export default AppDashboard;
